<template>
    <div>
        <!-- Yükleniyor -->
        <div v-if="formLoading" class="text-center py-5">
            <b-spinner variant="primary"/>
        </div>

        <div v-else>
            <b-card no-body class="mb-4 border-0 shadow-sm">
                <b-card-header class="bg-white font-weight-bold border-bottom py-2">
                    <i class="ri-user-line mr-2 text-primary"></i>
                    {{ $t('student_information') }}
                </b-card-header>
                <b-card-body class="pt-3 pb-2">
                    <b-row>
                        <b-col md="3" sm="6" class="mb-3">
                            <small class="text-muted d-block">{{ $t('student_id') }}</small>
                            <span class="font-weight-600">{{ isNotNullValue(formData.student_number) }}</span>
                        </b-col>
                        <b-col md="3" sm="6" class="mb-3">
                            <small class="text-muted d-block">{{ $t('name') }}</small>
                            <span class="font-weight-600">{{ isNotNullValue(formData.name) }}</span>
                        </b-col>
                        <b-col md="3" sm="6" class="mb-3">
                            <small class="text-muted d-block">{{ $t('surname') }}</small>
                            <span class="font-weight-600">{{ isNotNullValue(formData.surname) }}</span>
                        </b-col>
                        <b-col md="3" sm="6" class="mb-3">
                            <small class="text-muted d-block">{{ $t('current_balance') }}</small>
                            <span class="font-weight-600">{{ currencyFormat(isNotNullValue(formData.amount)) }}</span>
                        </b-col>
                        <b-col md="3" sm="6" class="mb-3">
                            <small class="text-muted d-block">{{ $t('due_date') }}</small>
                            <span class="font-weight-600">{{ isNotNullValue(formData.due_date) }}</span>
                        </b-col>
                      <b-col md="3" sm="6" class="mb-3">
                        <small class="text-muted d-block">{{ $t('payment_date') }}</small>
                        <span class="font-weight-600">{{ isNotNullValue(formData.payment_date) }}</span>
                      </b-col>
                      <b-col md="3" sm="6" class="mb-3">
                        <small class="text-muted d-block">{{ $t('days_to_close_balance') }}</small>
                        <span class="font-weight-600">{{ isNotNullValue(formData.days_to_close_balance) }}</span>
                      </b-col>
                        <b-col md="3" sm="6" class="mb-3">
                            <small class="text-muted d-block">{{ $t('program') }}</small>
                            <span class="font-weight-600">{{ isNotNullValue(formData.program) }}</span>
                        </b-col>
                        <b-col md="3" sm="6" class="mb-3">
                            <small class="text-muted d-block">{{ $t('student_status') }}</small>
                            <span class="font-weight-600">{{ isNotNullValue(formData.student_status_name) }}</span>
                        </b-col>
                        <b-col md="3" sm="6" class="mb-3">
                            <small class="text-muted d-block">{{ $t('registration_type') }}</small>
                            <span class="font-weight-600">{{ isNotNullValue(formData.registration_type_name) }}</span>
                        </b-col>
                      <b-col md="3" sm="6" class="mb-3">
                        <small class="text-muted d-block">{{ $t('send_to_cfo_date') }}</small>
                        <span class="font-weight-600">{{ isNotNullValue(formData.send_to_cfo_date) }}</span>
                      </b-col>
                      <b-col md="3" sm="6" class="mb-3">
                        <small class="text-muted d-block">{{ $t('collection_referral_date') }}</small>
                        <span class="font-weight-600">{{ isNotNullValue(formData.collection_referral_date) }}</span>
                      </b-col>
                      <b-col md="3" sm="6" class="mb-3">
                        <small class="text-muted d-block">{{ $t('cfo_approval_date') }}</small>
                        <span class="font-weight-600">{{ isNotNullValue(formData.cfo_approval_date) }}</span>
                      </b-col>
                      <b-col md="3" sm="6" class="mb-3">
                        <small class="text-muted d-block">{{ $t('president_approval_date') }}</small>
                        <span class="font-weight-600">{{ isNotNullValue(formData.president_approval_date) }}</span>
                      </b-col>

                    </b-row>
                </b-card-body>
            </b-card>

            <b-card no-body class="border-0 shadow-sm">
                <b-card-header class="bg-white font-weight-bold border-bottom py-2">
                    <i class="ri-settings-3-line mr-2 text-primary"></i>
                    {{ $t('step_status_update') }}
                </b-card-header>
                <b-card-body class="pt-3 pb-2">
                    <ValidationObserver ref="updateFormValidate">
                        <b-row>
                            <b-col md="4" sm="12" class="mb-3">
                                <ValidationProvider name="step" rules="required" v-slot="{ errors }">
                                    <b-form-group :label="$t('step')">
                                        <ParameterSelectbox code="accounts_receivable_steps" :rank-prefix="true" v-model="updateForm.step" :validate-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="4" sm="12" class="mb-3">
                                <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                                    <b-form-group :label="$t('status')">
                                        <ParameterSelectbox code="accounts_receivable_statuses" v-model="updateForm.status" :validate-error="errors[0]"/>

                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="4" sm="12" class="mb-3 d-flex align-items-center">
                                <b-button
                                    variant="primary"
                                    :disabled="updateLoading"
                                    @click="saveUpdate"
                                    class="w-100"
                                >
                                    <b-spinner small v-if="updateLoading"/>
                                    {{ $t('save').toUpperCase() }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </ValidationObserver>
                </b-card-body>
            </b-card>

            <b-card no-body class="border-0 shadow-sm mt-3">
                <b-card-header class="bg-white font-weight-bold border-bottom py-2 d-flex justify-content-between align-items-center">
                    <span>
                        <i class="ri-contacts-line mr-2 text-primary"></i>
                        {{ $t('contacts') }}
                    </span>
                    <b-button size="sm" variant="primary" @click="openContactForm(null)">
                        <i class="ri-add-line mr-1"></i>{{ $t('add_note') }}
                    </b-button>
                </b-card-header>
                <b-card-body class="p-0">
                    <div v-if="contactsLoading" class="text-center py-4">
                        <b-spinner variant="primary" small/>
                    </div>
                    <div v-else-if="contacts.length === 0" class="text-center text-muted py-4">
                        {{ $t('no_info_found') }}
                    </div>
                    <b-table
                        v-else
                        :items="contacts"
                        :fields="contactFields"
                        responsive
                        striped
                        hover
                        class="mb-0"
                    >
                        <template #cell(actions)="{ item }">
                            <div class="d-flex">
                                <b-button size="sm" variant="outline-primary" class="mr-1" @click="openContactForm(item)">
                                    <i class="ri-edit-box-line"></i>
                                </b-button>
                                <b-button size="sm" variant="outline-danger" @click="deleteContact(item.id)">
                                    <i class="ri-delete-bin-2-line"></i>
                                </b-button>
                            </div>

                        </template>
                    </b-table>
                </b-card-body>
            </b-card>

          <b-card no-body class="border-0 shadow-sm mt-3">
            <b-card-header class="bg-white font-weight-bold border-bottom py-2 d-flex justify-content-between align-items-center">
                    <span>
                        <i class="ri-file-search-line mr-2 text-primary"></i>
                        Logs
                    </span>
            </b-card-header>
            <b-card-body class="p-0">
              <div v-if="logsLoading" class="text-center py-4">
                <b-spinner variant="primary" small/>
              </div>
              <div v-else-if="logs.length === 0" class="text-center text-muted py-4">
                {{ $t('no_logs_found') }}
              </div>
              <b-table
                  v-else
                  :items="logs"
                  :fields="logFields"
                  responsive
                  thead-class="d-none"
                  striped
                  hover
                  class="mb-0"
              >
              </b-table>
            </b-card-body>
          </b-card>
        </div>

        <CommonModal ref="contactFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="resetContactForm">
            <template v-slot:CommonModalTitle>
                {{ (contactForm.id ? $t('edit') : $t('add_note')).toUpperCase() }}
            </template>
            <template v-slot:CommonModalContent>
                <ValidationObserver ref="contactModalValidate">
                    <b-row>
                        <b-col cols="12" class="mb-3">
                            <ValidationProvider name="via" rules="required" v-slot="{ errors }">
                                <b-form-group :label="$t('via')">
                                    <b-form-select
                                        v-model="contactForm.via"
                                        :options="viaOptions"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                    />
                                    <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" class="mb-3">
                            <ValidationProvider name="note" rules="required" v-slot="{ errors }">
                                <b-form-group :label="$t('note')">
                                    <b-form-textarea
                                        v-model="contactForm.note"
                                        rows="4"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                    />
                                    <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12">
                            <b-button
                                variant="primary"
                                block
                                :disabled="contactSaveLoading"
                                @click="saveContact"
                            >
                                <b-spinner small v-if="contactSaveLoading"/>
                                {{ $t('save').toUpperCase() }}
                            </b-button>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </template>
        </CommonModal>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CommonModal from '@/components/elements/CommonModal';
import AccountsReceivablesDashboardServices from '@/services/AccountsReceivablesDashboardServices';
import AccountsReceivableContactsService from '@/services/AccountsReceivableContactsService';
import qs from 'qs';
import moment from "moment";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        CommonModal,
    },
    props: {
        formId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {

            formLoading: false,
            formData: {},
            updateLoading: false,
            updateForm: {
                step: null,
                status: null,
                amount:null,
                customer_id:null,
                due_date:null
            },
            contacts: [],
            contactsLoading: false,
            contactSaveLoading: false,
            contactForm: {
                id: null,
                via: null,
                note: null,
            },
            contactFields: [
                { key: 'via',    label: this.$t('via'),    sortable: true },
                { key: 'note',   label: this.$t('note'),   sortable: false },
                { key: 'created_by_name',   label: this.$t('created_by'),   sortable: false },
                { key: 'created_at',   label: this.$t('created_at'),   sortable: true },
                { key: 'actions', label: '', class: 'text-center' },
            ],
            logs: [],
            logsLoading: false,
            logFields: [
              { key: 'date',    label: this.$t('date'),    sortable: false, class: 'width-140'},
              { key: 'text',   label: " ",   sortable: false },
            ],
            viaOptions: [
                { value: null,    text: this.$t('select') },
                { value: 'Phone', text: 'Phone' },
                { value: 'Email', text: 'Email' },
            ],
        };
    },
    watch: {
        formId(val) {
            this.loadAll(val);
        },
    },
    created() {
        this.loadAll(this.formId);
    },
    methods: {
        loadAll(id) {
            this.getRecord(id);
            this.getContacts(id);
            this.getLogs(id);
        },
        getRecord(id) {
            this.formLoading = true;
            AccountsReceivablesDashboardServices.getOne(id)
                .then((response) => {
                    this.formData = response.data.data;
                    this.updateForm.step   = this.formData.step;
                    this.updateForm.status = this.formData.status;
                })
                .catch((error) => {
                    this.showErrors(error, null);
                })
                .finally(() => {
                    this.formLoading = false;
                });
        },

        async saveUpdate() {
            const isValid = await this.$refs.updateFormValidate.validate();
            if (!isValid) return;
            this.updateLoading = true;
            this.updateForm.customer_id=this.formData.customer_id
            this.updateForm.due_date=this.formData.due_date
                // moment(this.formData.due_date).format('DD/MM/YYYY')
          const updateData = {
              status: this.formData.status,
              step: this.formData.step,
          }
            AccountsReceivablesDashboardServices.update(this.formId, updateData)
                .then((response) => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$emit('updateSuccess');
                })
                .catch((error) => {
                    this.showErrors(error, this.$refs.updateFormValidate);
                })
                .finally(() => {
                    this.updateLoading = false;
                });
        },

        getContacts(accountsReceivableId) {
            this.contactsLoading = true;
            const config = {
                params: { filter: { accounts_receivable_id: accountsReceivableId } },
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };
            AccountsReceivableContactsService.getAll(config)
                .then((response) => {
                    this.contacts = response.data.data;
                })
                .catch((error) => {
                    this.showErrors(error, null);
                })
                .finally(() => {
                    this.contactsLoading = false;
                });
        },
        openContactForm(item) {
            if (item) {
                this.contactForm = { id: item.id, via: item.via, note: item.note };
            } else {
                this.resetContactForm();
            }
            this.$refs.contactFormModal.$refs.commonModal.show();
        },
        resetContactForm() {
            this.contactForm = { id: null, via: null, note: null };
            if (this.$refs.contactModalValidate) {
                this.$refs.contactModalValidate.reset();
            }
        },
        async saveContact() {
            const isValid = await this.$refs.contactModalValidate.validate();
            if (!isValid) return;

            this.contactSaveLoading = true;
            const payload = {
                accounts_receivable_id: this.formId,
                via: this.contactForm.via,
                note: this.contactForm.note,
            };

            const request = this.contactForm.id
                ? AccountsReceivableContactsService.update(this.contactForm.id, payload)
                : AccountsReceivableContactsService.store(payload);

            request.then((response) => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$refs.contactFormModal.$refs.commonModal.hide();
                    this.resetContactForm();
                    this.getContacts(this.formId);
                })
                .catch((error) => {
                    this.showErrors(error, this.$refs.contactModalValidate);
                })
                .finally(() => {
                    this.contactSaveLoading = false;
                });
        },
        deleteContact(id) {
            this.deleteModal(() => {
                AccountsReceivableContactsService.remove(id)
                    .then((response) => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.getContacts(this.formId);
                    })
                    .catch((error) => {
                        this.$toast.error(this.$t('api.' + error.data.message));
                    });
            });
        },
      getLogs(accountsReceivableId) {
        this.logsLoading = true;
        AccountsReceivablesDashboardServices.getLogs(accountsReceivableId)
            .then((response) => {
              this.logs = response.data.data;
            })
            .catch((error) => {
              this.showErrors(error, null);
            })
            .finally(() => {
              this.logsLoading = false;
            });
      },
    },
};
</script>

<style scoped>
.font-weight-600 { font-weight: 600; }
</style>
